import { useCallback } from 'react';
import { useClerkToken } from 'src/hooks/useClerkToken';
import { getTraceId } from 'src/lib/trace';

const buildHeaders = (headers?: HeadersInit, token?: string | null) => {
  const next = new Headers(headers || undefined);
  if (token) {
    next.set('Authorization', `Bearer ${token}`);
  }
  next.set('X-Trace-Id', getTraceId());
  return next;
};

export const useAuthedFetch = () => {
  const { getToken } = useClerkToken('dashboard-jwt');

  return useCallback(
    async (input: RequestInfo | URL, init?: RequestInit) => {
      const token = await getToken();
      const headers = buildHeaders(init?.headers, token);
      return fetch(input, { ...init, headers });
    },
    [getToken]
  );
};
